import React, { useEffect, useState } from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { TypeaheadInput, TypeaheadItem } from '../../../../ui';
import { useResolve } from '../../../Container';

export const TemplateTagInput = ({ error, onChange }: { error?: boolean, onChange(newValue: TypeaheadItem[]): void }) => {

    const api = useResolve(ApiClient);
    const tagSource = async (search: string) => {
        const hits = await api.exec(v2.templates.tags.list(search));
        const create = !!search.trim() ? [TypeaheadItem(`new:${search}`, `Create: ${search}`)] : [];
        return [...hits, ...create];
    };

    const [tags, setTags] = useState<TypeaheadItem[]>([] as TypeaheadItem[]);

    const onSelect = (item: TypeaheadItem) => { };

    const onAdd = (items: TypeaheadItem[]) => {
        setTags([...tags, ...items]);
    };

    const onRemove = (item: TypeaheadItem) => {
        setTags(s => s.filter(t => t.id !== item.id));
    };

    useEffect(() => onChange(tags), [tags]);

    return <TypeaheadInput
        error={error}
        label="Categories:"
        itemMode
        items={tags}
        triggerOnClick
        typeaheadSource={tagSource}
        onItemAdd={onAdd}
        onItemRemove={onRemove}
        onTypeaheadSelect={onSelect}
    />;
};
